import {
  FeatureImpl,
  IFeatureRepository,
} from "api/merchantRepository/features/FeatureRepository";
import {
  ITopupManagementRepository,
  TopupManagementImpl,
} from "api/repositories/packagesManagement/topupManagement/TopupManagementRepository";
import {
  IRoamingPartnerRepository,
  RoamingPartnerImpl,
} from "api/repositories/roamingPartnerManagement/RoamingPartnerRepository";
import { ActionInjection } from "app/actions/di/ActionInjection";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";
import { FilterInjection } from "app/filters/di/FilterInjection";
import { AppStartUpInjection } from "app/startup/di/AppStartUpInjection";
import { SidebarMenuInjection } from "components/sidebar/di/SidebarMenuInjection";

export class AppBasedServiceInjection extends InjectionModule {
  private static readonly featureRepositoryToken = Symbol("IFeatureRepository");
  private static readonly roamingPartnerRepositoryToken = Symbol(
    "IRoamingPartnerRepository",
  );
  private static readonly packageManagementRepositoryToken = Symbol(
    "ITopupManagementRepository",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.featureRepositoryToken,
      useClass: FeatureImpl,
    },
    {
      scope: "otherRepo",
      token: this.roamingPartnerRepositoryToken,
      useClass: RoamingPartnerImpl,
    },
    {
      scope: "otherRepo",
      token: this.packageManagementRepositoryToken,
      useClass: TopupManagementImpl,
    },
  ];

  static getFeatureRepo(): IFeatureRepository {
    return this.resolve(this.featureRepositoryToken);
  }

  static getRoamingPartnerRepo(): IRoamingPartnerRepository {
    return this.resolve(this.roamingPartnerRepositoryToken);
  }

  static getPackageManagementRepo(): ITopupManagementRepository {
    return this.resolve(this.packageManagementRepositoryToken);
  }
}

export class AppCoreInjection {
  static initialize(): void {
    FilterInjection.initialize();
    ActionInjection.initialize();
    SidebarMenuInjection.initialize();
    AppBasedServiceInjection.initialize();
    AppStartUpInjection.initialize();
  }
}
